import { SET_MAILING_COUPON_CONFIGS } from '../../actionTypes/mailings'

const initialState = {
	mailingCouponConfigs: [],
}

export function mailingsReducer (state = initialState, action) {
	switch (action.type) {
		case SET_MAILING_COUPON_CONFIGS:
			return {
				...state,
				mailingCouponConfigs: action.value,
			}
		default:
			return state
	}
}
